/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17c8c810f288fa2c4d58e06371883a6e>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';

import { IconFacade } from '@atlaskit/icon/base';
import type { GlyphProps } from '@atlaskit/icon/types';

const PageLiveDoc16Icon = (props: Omit<GlyphProps, 'primaryColor' | 'secondaryColor' | 'size'>) => (
	<IconFacade
		dangerouslySetGlyph={`<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M3 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h2.5a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m8.293-5.793-2.854 4.05c-.21.314.009.743.38.743h1.993c.149 0 .259.143.224.292l-.443 2.121c-.119.511.538.812.828.38l2.854-4.05c.21-.314-.008-.743-.38-.743h-1.993a.236.236 0 0 1-.224-.292l.443-2.121c.119-.511-.538-.812-.828-.38" clip-rule="evenodd"/></svg>`}
		// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
		{...props}
		size="small"
	/>
);

PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default PageLiveDoc16Icon;
